import React, { useEffect } from 'react';
import styles from './Cookies.module.css';
import gsap from 'gsap';
import axios from 'axios';
import { ServicesType } from '../../utils/Types/ServicesTypes';
import { useNavigate } from 'react-router-dom';

export type CookiesProps = {
    setNavBackground: React.Dispatch<React.SetStateAction<boolean>>
}

const Cookies = (props: CookiesProps) => {
    useEffect(() => {
        props.setNavBackground(true);
    }, [props]);

    return (
        <div className={styles.container}>
            <main className={styles.content}>
                <h1 className={styles.title}>Política de Cookies</h1>

                <p className={styles.description}>
                    A SAZULI utiliza cookies neste website para garantir o seu
                    correto funcionamento, melhorar a experiência de navegação e
                    analisar a utilização do website.
                </p>

                <p className={styles.description}>
                    Ao continuar a navegar neste website, o utilizador consente
                    a utilização de cookies, de acordo com a presente Política de
                    Cookies, salvo se os tiver desativado nas definições do seu
                    navegador ou através das preferências apresentadas no banner
                    de cookies.
                </p>

                <section className={styles.item}>
                    <h2 className={styles.subtitle}>O QUE SÃO COOKIES?</h2>

                    <p className={styles.description}>
                        Os cookies são pequenos ficheiros de texto armazenados no
                        dispositivo do utilizador, como um computador, tablet ou
                        smartphone, quando visita um website.
                    </p>

                    <p className={styles.description}>
                        Estes ficheiros permitem reconhecer o dispositivo e
                        guardar determinadas informações relacionadas com a
                        navegação.
                    </p>
                </section>

                <section className={styles.item}>
                    <h2 className={styles.subtitle}>
                        PARA QUE UTILIZAMOS COOKIES?
                    </h2>

                    <p className={styles.description}>
                        Os cookies utilizados pela SAZULI destinam-se a:
                    </p>

                    <ul className={`${styles.list} ${styles.description}`}>
                        <li>Garantir o correto funcionamento do website;</li>
                        <li>Melhorar a experiência de navegação;</li>
                        <li>Memorizar preferências do utilizador;</li>
                        <li>
                            Recolher dados estatísticos anónimos sobre a utilização
                            do website, permitindo melhorar continuamente os
                            conteúdos e serviços disponibilizados.
                        </li>
                    </ul>
                </section>

                <section className={styles.item}>
                    <h2 className={styles.subtitle}>
                        TIPOS DE COOKIES UTILIZADOS
                    </h2>

                    <div className={styles.cookieType}>
                        <h3 className={styles.cookieTitle}>
                            Cookies Essenciais
                        </h3>

                        <p className={styles.description}>
                            São indispensáveis para o funcionamento do website e
                            permitem funcionalidades básicas, como a navegação
                            entre páginas e a segurança da sessão. Estes cookies
                            não podem ser desativados.
                        </p>
                    </div>

                    <div className={styles.cookieType}>
                        <h3 className={styles.cookieTitle}>
                            Cookies de Desempenho e Estatística
                        </h3>

                        <p className={styles.description}>
                            Permitem recolher informação estatística, de forma
                            agregada e anónima, sobre a utilização do website,
                            ajudando a compreender como os visitantes interagem
                            com as diferentes páginas.
                        </p>
                    </div>

                    <div className={styles.cookieType}>
                        <h3 className={styles.cookieTitle}>
                            Cookies Funcionais
                        </h3>

                        <p className={styles.description}>
                            Permitem recordar preferências do utilizador,
                            proporcionando uma experiência de navegação mais
                            personalizada.
                        </p>
                    </div>
                </section>

                <section className={styles.item}>
                    <h2 className={styles.subtitle}>GESTÃO DE COOKIES</h2>

                    <p className={styles.description}>
                        O utilizador pode, a qualquer momento, configurar o seu
                        navegador para bloquear ou eliminar cookies.
                    </p>

                    <p className={styles.description}>
                        A desativação de alguns cookies poderá afetar o correto
                        funcionamento de determinadas funcionalidades do
                        website.
                    </p>

                    <p className={styles.description}>
                        Consulte as instruções do navegador utilizado para obter
                        mais informações sobre a gestão de cookies.
                    </p>
                </section>

                <section className={styles.item}>
                    <h2 className={styles.subtitle}>COOKIES DE TERCEIROS</h2>

                    <p className={styles.description}>
                        O website poderá utilizar serviços de terceiros, como
                        ferramentas de análise estatística ou conteúdos
                        incorporados, que poderão instalar cookies próprios.
                    </p>

                    <p className={styles.description}>
                        A utilização desses cookies encontra-se sujeita às
                        políticas de privacidade das respetivas entidades.
                    </p>
                </section>

                <section className={styles.item}>
                    <h2 className={styles.subtitle}>
                        ALTERAÇÕES À POLÍTICA DE COOKIES
                    </h2>

                    <p className={styles.description}>
                        A SAZULI reserva-se o direito de alterar a presente
                        Política de Cookies sempre que necessário, sendo
                        quaisquer alterações publicadas nesta página.
                    </p>
                </section>

                <section className={styles.item}>
                    <h2 className={styles.subtitle}>CONTACTOS</h2>

                    <p className={styles.description}>
                        Caso tenha alguma questão relacionada com a utilização
                        de cookies neste website, poderá contactar-nos através
                        de:
                    </p>

                    <div className={styles.info}>
                        <p className={styles.description}>
                            Sazuli – Importação e Exportação de Cerâmicas e
                            Sanitários, Lda.
                        </p>

                        <div>
                            <span
                                className={`${styles.bold} ${styles.description}`}
                            >
                                E-mail:
                            </span>

                            <a
                                href="mailto:geral@sazuli.pt"
                                className={styles.contactLink}
                            >
                                geral@sazuli.pt
                            </a>
                        </div>

                        <div>
                            <span
                                className={`${styles.bold} ${styles.description}`}
                            >
                                Telefone:
                            </span>

                            <a
                                href="tel:+351255490460"
                                className={styles.contactLink}
                            >
                                (+351) 255 490 460
                            </a>

                            <span className={styles.description}>
                                {' '}
                                (Chamada para a rede fixa nacional)
                            </span>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default Cookies;